module.exports = __webpack_public_path__ + "img/planta_11.99241f8d.png";